/* eslint-disable react/prop-types */
import React from 'react';
import { logo } from '../imagepath';
import './SupplyStorefront.css';

/**
 * "Recommended Equipment" banner — safety & first-aid equipment referenced in the
 * Active Shooter Response and First Aid training courses AngelWatch sells to daycare
 * schools. One wide banner, responsive via SupplyStorefront.css.
 *
 * Reusable + portable: intended to sit at the TOP of every school admin dashboard.
 * For now shown only on the sysadmin Test page as a mock.
 *
 * Props:
 *   affiliateUrl  Amazon storefront URL. Until provided, the CTA renders as a disabled
 *                 "coming soon" placeholder so no dead link goes to customers.
 */
const SupplyStorefront = ({ affiliateUrl = null }) => {
  const live = !!affiliateUrl;

  return (
    <div className="aw-store">
      <div className="aw-store__row">
        <div className="aw-store__left">
          <div className="aw-store__logo">
            <img src={logo} alt="AngelWatch" />
          </div>
          <div className="aw-store__text">
            <div className="aw-store__title">Recommended Equipment</div>
            <div className="aw-store__sub">
              Safety and first-aid equipment from your Active Shooter Response and First Aid
              training courses — vetted and ready to order for your center.
            </div>
          </div>
        </div>

        <div className="aw-store__cta-wrap">
          {live ? (
            <a
              className="aw-store__cta"
              href={affiliateUrl}
              target="_blank"
              rel="noopener noreferrer sponsored"
            >
              Shop Recommended Equipment&nbsp;→
            </a>
          ) : (
            <>
              {/* Rendered as a non-disabled <span> so Bootstrap's global :disabled
                  background style can't override the banner's dark-grey placeholder. */}
              <span
                className="aw-store__cta aw-store__cta--disabled"
                role="button"
                aria-disabled="true"
                title="Storefront link coming soon"
              >
                Shop Recommended Equipment&nbsp;→
              </span>
              <div className="aw-store__soon">Link coming soon</div>
            </>
          )}
        </div>
      </div>

      {/* FTC / Amazon Associates affiliate disclosure */}
      <div className="aw-store__disclosure">
        As an Amazon Associate, AngelWatch earns from qualifying purchases.
      </div>
    </div>
  );
};

export default SupplyStorefront;
